const WEEKDAYS_BY_TYPE = {
    mondayToFriday: [1, 2, 3, 4, 5],
    mondayToSaturday: [1, 2, 3, 4, 5, 6],
};

export default class Interval {
    static getWeekdays(intervalType) {
        return WEEKDAYS_BY_TYPE[intervalType] || null;
    }

    static coversWeekday(intervalType, weekday) {
        const weekdays = Interval.getWeekdays(intervalType);

        return weekdays === null || weekdays.includes(weekday);
    }
}
